import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuestionContext } from "../../shared/context/QuestionContext";
import "./questions.css";

export default function QuestionLawyerAnswer(props) {
  const { answerQuestion } = useQuestionContext();
  const [answer, setAnswer] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | error
  const { t } = useTranslation();

  async function handleSubmit(e) {
    // Without this the browser reloaded the whole page on submit.
    e.preventDefault();
    setStatus("sending");
    const res = await answerQuestion({ _id: props.id, text: answer.trim() });
    if (res?.status === 200 || res?.data?.status === "success") {
      setAnswer("");
      setStatus("idle");
      props.onAnswered && props.onAnswered();
    } else {
      setStatus("error");
    }
  }

  return (
    <form className="avc-answer-form" onSubmit={handleSubmit}>
      <h2 className="avc-answer-form__title">
        <i className="fas fa-balance-scale" aria-hidden="true"></i>
        {t("Answer_as_a_lawyer")}
      </h2>
      {status === "error" && (
        <p className="avc-alert avc-alert--error" role="alert">
          <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
          {t("qa_answer_error")}
        </p>
      )}
      <label className="avc-field">
        <span className="avc-field__label">{t("Answer_Question")}</span>
        <textarea
          className="avc-textarea"
          required
          rows={5}
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
        />
      </label>
      <button
        type="submit"
        className="avc-btn avc-btn--gold"
        disabled={status === "sending" || !answer.trim()}
      >
        <i className="far fa-paper-plane" aria-hidden="true"></i>
        {t("Answer")}
      </button>
    </form>
  );
}
